<div class="dropdown-container" #dropdownContainer>
    @if (label) {
        <div class="dropdown-label">{{ label }}</div>
    }
    <div class="dropdown-button" [class.disabled]="disabled" [class.active]="isOpen" (click)="toggleDropdown()">
        <span class="dropdown-selected-text">{{ getSelectedText() }}</span>
        <div class="dropdown-actions">
            @if (selectedOptions.length > 0) {
                <button class="dropdown-clear-btn" (click)="clearSelections($event)"
                    title="Limpiar selección">
                    ×
                </button>
            }
            <span class="dropdown-arrow" [class.open]="isOpen">▼</span>
        </div>
    </div>

    @if (isOpen) {
        <div class="dropdown-menu">
            @if (showSearch) {
            <div class="dropdown-search">
                <div class="search-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                </div>
                <input type="text" [placeholder]="searchPlaceholder" [(ngModel)]="searchText" (input)="filterOptions()"
                    (click)="$event.stopPropagation()">
                </div>
            }
    
            <div class="dropdown-options-container">
                <div class="dropdown-options">
                    @for (option of filteredOptions; track $index) {
                    <div class="dropdown-option"
                        [class.selected]="isSelected(option)" (click)="toggleOption(option, $event)">
                        <span class="option-text">{{ option.text }}</span>
                        @if (isSelected(option) && !multiple) {
                            <span class="check-icon">✓</span>
                        }
                        @if (multiple) {
                            <div class="checkbox">
                                <input type="checkbox" [checked]="isSelected(option)" (click)="$event.stopPropagation()"
                                    (change)="toggleOption(option)">
                                <span class="checkbox-custom"></span>
                            </div>
                        }
                    </div>
                    }
                </div>
            </div>
    
            @if (multiple && selectedOptions.length > 0) {
                <div class="dropdown-footer">
                    <div class="selected-count">{{ selectedOptions.length }} elementos seleccionados</div>
                    <button class="apply-btn" (click)="toggleDropdown()">Aplicar</button>
                </div>
            }
        </div>
    }
</div>